import { ArrowUp, ArrowDown, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ImageCardProps {
  url: string;
  alt: string;
  order: number;
  isFirst: boolean;
  isLast: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onDelete: () => void;
  onAltChange: (alt: string) => void;
}

export default function ImageCard({
  url,
  alt,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  onDelete,
  onAltChange,
}: ImageCardProps) {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden flex flex-col">
      <img src={url} alt={alt} className="w-full h-40 object-cover" />
      <div className="p-2 flex flex-col gap-2">
        <Input
          type="text"
          defaultValue={alt}
          placeholder="Texte alternatif"
          onBlur={(e) => onAltChange(e.target.value)}
          className="text-sm"
        />
        <div className="flex items-center justify-between gap-1">
          <div className="flex gap-1">
            <button
              onClick={onMoveUp}
              disabled={isFirst}
              className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <ArrowUp size={16} />
            </button>
            <button
              onClick={onMoveDown}
              disabled={isLast}
              className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <ArrowDown size={16} />
            </button>
          </div>
          <button
            onClick={onDelete}
            className="p-1 rounded hover:bg-red-50 text-red-500"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
